import {useEffect} from "react";

import {GuideStateApi} from "@khan/guide-state";
import {useUserAttributes} from "@khan/shared-core";

import {useFetchCooldownStatus} from "../queries/use-fetch-cooldown-status.ts";

/**
 * Fetches the Khanmigo cooldown status, syncing the status with the
 * GuideState as necessary.
 */
export const useSyncCooldownStatusGuideState = () => {
    const userAttributes = useUserAttributes();
    const skip = !userAttributes?.isAIGuideEnabled;
    const cooldownStatusResponse = useFetchCooldownStatus({skip});

    // Note: any updates to the guide state API must be done in a
    // useEffect hook (else the update might come when another
    // component is rendering).
    useEffect(() => {
        if (
            cooldownStatusResponse.status === "success" ||
            cooldownStatusResponse.status === "expired"
        ) {
            GuideStateApi.set("isOffline", cooldownStatusResponse.hasCooldown);
            GuideStateApi.set(
                "cooldownStatus",
                cooldownStatusResponse.cooldownStatus,
            );
        }
    }, [cooldownStatusResponse]);
};
